

export class EmployeeResponse {
  _id: string = "";
  created_at: string = "";
  updated_at: string = "";
  brand_id: string = "";
  department_id: string = "";
  department_name: string = "";
  status: number = 1;
  name: string = "";
  birthday: string = "";
  gender: number = 0;
  avatar: string = "";
  phone: string = "";
  address: string = "";
  id_card_number: string = "";
  username: string = "";
  totp_secret: string = "";
  totp_qr_code: string = "";
  is_owner: number = 0;
  branches: Branch[] = [];
  branch_ids: string[] = [];
  privileges: Privileges[] = [];
  access_token: string = "";
  joining_date: string = "";
  password: string = "";

  constructor(data?: Partial<EmployeeResponse>) {
    Object.assign(this, data);
  }
}

export class Branch {
  _id: string = "";
  name: string = "";
  constructor(data?: Partial<Branch>) {
    Object.assign(this, data);
  }
}

export class Privileges {
  _id: string = "";
  name: string = "";
  code: string = "";

  constructor(data?: Partial<Privileges>) {
    Object.assign(this, data);
  }
}
